export const examTypes = [
  'TYT–AYT',
  'LGS',
  'YDT',
  'KPSS',
  'DGS',
  'MSÜ'
];

export const examLessons = {
  'TYT–AYT': [
    { name: 'Türkçe', totalQuestions: 40 },
    { name: 'Matematik', totalQuestions: 40 },
    { name: 'Fen Bilimleri', totalQuestions: 40 },
    { name: 'Sosyal Bilimler', totalQuestions: 40 },
    { name: 'Edebiyat', totalQuestions: 40 }
  ],
  'LGS': [
    { name: 'Türkçe', totalQuestions: 20 },
    { name: 'Matematik', totalQuestions: 20 },
    { name: 'Fen Bilimleri', totalQuestions: 20 },
    { name: 'Sosyal Bilimler', totalQuestions: 20 },
    { name: 'İngilizce', totalQuestions: 10 }
  ],
  'YDT': [
    { name: 'Dil Bilgisi', totalQuestions: 20 },
    { name: 'Okuma', totalQuestions: 20 },
    { name: 'Kelime Bilgisi', totalQuestions: 20 },
    { name: 'Cloze Test', totalQuestions: 10 },
    { name: 'Çeviri', totalQuestions: 10 }
  ],
  'KPSS': [
    { name: 'Türkçe', totalQuestions: 30 },
    { name: 'Matematik', totalQuestions: 30 },
    { name: 'Tarih', totalQuestions: 30 },
    { name: 'Coğrafya', totalQuestions: 18 },
    { name: 'Vatandaşlık', totalQuestions: 12 }
  ],
  'DGS': [
    { name: 'Sayısal Yetenek', totalQuestions: 60 },
    { name: 'Sözel Yetenek', totalQuestions: 60 },
    { name: 'Matematik', totalQuestions: 40 },
    { name: 'Türkçe', totalQuestions: 40 },
    { name: 'Mantık', totalQuestions: 20 }
  ],
  'MSÜ': [
    { name: 'Türkçe', totalQuestions: 40 },
    { name: 'Matematik', totalQuestions: 40 },
    { name: 'Fen Bilimleri', totalQuestions: 20 },
    { name: 'Sosyal Bilimler', totalQuestions: 20 },
    { name: 'Genel Yetenek', totalQuestions: 40 }
  ]
};

export const getUserTitle = (username) => {
  if (!username) return '';
  return `${username}'nin Dünyası`;
};